import napStyles from './../nap.json'

export default {
  color: napStyles.colors.PrimaryBlack,
  iconColor: napStyles.colors.PrimaryBlack,
  dashLength: 32,
  dashHeight: 1
}
